import { TEditableFieldWrapperProps } from './EditableFieldWrapper.types';
import { SEditableFieldWrapper } from './EditableFieldWrapper.styles';

const EditableFieldWrapper = (props: TEditableFieldWrapperProps) => {
  return <SEditableFieldWrapper {...props} />;
};

export default EditableFieldWrapper;
